import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BuzzCardComponent } from './buzz.component';
import { CardModule } from '../card.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LazyLoadImageModule,
    CardModule
  ],
  declarations: [
    BuzzCardComponent
  ],
  exports: [
    BuzzCardComponent
  ]
})
export class BuzzCardModule { }
